import Vue from 'vue'

// check if the browser request is from obs
const userAgent = window.navigator.userAgent
const isOBS = userAgent.includes(' OBS/')

Vue.prototype.$isOBS = isOBS
